<template>
  <div
    v-html="sectionData.html"
    :class="`${
      sectionData.class !== undefined
        ? sectionData.class
        : 'q-px-md html-component'
    }`"
    :style="`${sectionData.style !== undefined ? sectionData.style : ''}`"
  ></div>
</template>
<script>
export default {
  name: "DHtml",
  props: {
    sectionData: {
      type: Object,
      default: () => {
        return {
          html: "",
          class: "q-px-md html-component",
        };
      },
    },
  },
};
</script>

<style lang="sass" scoped>
@import url('./DHtml.sass')
</style>
